export default {"src":"/_next/static/media/arrow-right-white.a72fc61c.svg","height":4,"width":4,"blurWidth":0,"blurHeight":0};